import React, { useEffect, useState } from 'react';
import { Switch, InputNumber, Typography, Flex } from 'antd';

export default function CameraConfig({
  currentCameraConfig,
  callBack,
  type,
  setDisableBtn,
}) {
  return (
    <>
      <Typography.Title level={5}>Camera Config</Typography.Title>
      <Flex vertical gap={10}>
        <div>
          <Typography.Paragraph strong>
            Near (Min Distance 0.1-2)
          </Typography.Paragraph>
          <InputNumber
            defaultValue={currentCameraConfig.near}
            min={0.1}
            max={2}
            step={0.1}
            style={{ width: '100%' }}
            onChange={(value) => {
              callBack({ type, value: value, key: 'near' });
              setDisableBtn(false);
            }}
          />
        </div>
        <div>
          <Typography.Paragraph strong>
            Far (Max Distance 5-5000)
          </Typography.Paragraph>
          <InputNumber
            defaultValue={currentCameraConfig.far}
            min={5}
            max={5000}
            style={{ width: '100%' }}
            onChange={(value) => {
              callBack({ type, value: value, key: 'far' });
              setDisableBtn(false);
            }}
          />
        </div>
        <div>
          <Typography.Paragraph strong>Fov (Angle 25-90)</Typography.Paragraph>
          <InputNumber
            defaultValue={currentCameraConfig.fov}
            min={25}
            max={90}
            style={{ width: '100%' }}
            onChange={(value) => {
              callBack({ type, value: value, key: 'fov' });
              setDisableBtn(false);
            }}
          />
        </div>
        <div>
          <Typography.Paragraph strong>
            Min Avatar Speed (15-24)
          </Typography.Paragraph>
          <InputNumber
            defaultValue={currentCameraConfig.minSpeed}
            min={15}
            max={24}
            style={{ width: '100%' }}
            onChange={(value) => {
              callBack({ type, value: value, key: 'minSpeed' });
              setDisableBtn(false);
            }}
          />
        </div>
        <div>
          <Typography.Paragraph strong>
            Max Avatar Speed (25-70)
          </Typography.Paragraph>
          <InputNumber
            defaultValue={currentCameraConfig.maxSpeed}
            min={25}
            max={70}
            style={{ width: '100%' }}
            onChange={(value) => {
              callBack({ type, value: value, key: 'maxSpeed' });
              setDisableBtn(false);
            }}
          />
        </div>
        <div>
          <Typography.Paragraph strong>
            Camera in Third Person
          </Typography.Paragraph>

          <Switch
            onChange={(value) => {
              callBack({ type, value: value, key: 'isThirdPerson' });
              setDisableBtn(false);
            }}
            defaultChecked={currentCameraConfig.isThirdPerson}
          />
        </div>
      </Flex>

      <style>{`
                .ant-input-number .ant-input-number-handler-wrap{
                opacity:1 !important;
                }
            `}</style>
    </>
  );
}
